import type { MutualGuildItem, PublicUserProfile, UserSearchResult } from '../../types/index.js';
import { buildQuery, type RequestFn } from '../http.js';

/** User lookups: a public exact-by-username resolve + authed discovery search. */
export function makeUsersApi(request: RequestFn) {
  return {
    /** Resolve the public profile card behind `bunker.cispracs.ru/u/<name>`. */
    getUserByUsername: (username: string) =>
      request<{ user: PublicUserProfile }>(
        `/api/users/by-username/${encodeURIComponent(username)}`,
      ),
    /** Find people by username/display name (authed) — discovery for new users
     *  with no shared guild or DM yet. Each hit carries the caller's friend state. */
    searchUsers: (q: string, limit?: number, signal?: AbortSignal) =>
      request<{ users: UserSearchResult[] }>(
        `/api/users/search${buildQuery({ q, limit })}`,
        signal ? { signal } : undefined,
      ),
    /** Servers the caller and this user both belong to — powers the "общие
     *  серверы" strip in the profile card. Empty for self / blocked / no overlap. */
    getMutualGuilds: (userId: string) =>
      request<{ guilds: MutualGuildItem[] }>(
        `/api/users/${encodeURIComponent(userId)}/mutual-guilds`,
      ),
  };
}
